import { createId } from "@paralleldrive/cuid2";
import { kebabCase } from "@reactive-resume/utils";

export const uniqueResumeSlug = (title: string): string => {
  const base = kebabCase(title) || "resume";
  return `${base}-${createId().slice(-8)}`;
};

export const builderPath = (resumeId: string, firstRun = false): string =>
  firstRun ? `/builder/${resumeId}?onboarding=1` : `/builder/${resumeId}`;
